// @flow

import type {Language, Paging, ModalEventsOptions, EventsSortBy, SortDir} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, portfoliosSelectors, uiActions} from '@/store'
import Pagination from '@/controls/pagination'
import NotificationTable from './notification-table'

type Props = {
  l: Language,
  startDate: any,
  endDate: any,
  events: Array<any>,
  modalEventsPaging: Paging,
  modalEventsCount: number,
  fetchPortfolioModalEvents: (dates: ?Object) => void,
  fetchPortfolioEventsExport: () => void,
  setModalEventsPageNumber: (number) => void,
  modalEventsLoader: boolean,
  setModalEventsSortOptions: (EventsSortBy, ?SortDir) => void,
  modalSortOptions: ModalEventsOptions,
  langCode: string,
  countryCode: string,
}

const fetchEventsSortBy = (props) => (sortBy: EventsSortBy) => {
  props.setModalEventsPageNumber(0)
  props.setModalEventsSortOptions(sortBy)
  props.fetchPortfolioModalEvents({
    startDate: props.startDate,
    endDate: props.endDate,
  })
}

const RawModalContents = (props: Props) =>
  <div className='notification-modal-content'>
    {props.modalEventsLoader ? <div id='loader'></div> : null}
    <NotificationTable {...props} sortBy={fetchEventsSortBy(props)}
      sortOptions={props.modalSortOptions} loader={props.modalEventsLoader}
      langCode={props.langCode}/>
    <div className='flex-container'>
      <div className='events-exports'>
        {props.modalEventsCount > 0
          ? <button id="new_export" className="btn btn-success" onClick={() => props.fetchPortfolioEventsExport()}>
            {props.l('Export(.csv)')}
          </button> : ''}
      </div>
      <div className='pagination-table'>
        {props.modalEventsCount > props.modalEventsPaging.pageSize ? <Pagination
          activePage={props.modalEventsPaging.pageNumber + 1}
          pageSize={props.modalEventsPaging.pageSize}
          totalItems={props.modalEventsCount}
          onChange={(page) => {
            props.setModalEventsPageNumber(page - 1)
            props.fetchPortfolioModalEvents({
              startDate: props.startDate,
              endDate: props.endDate,
            })
          }}
        /> : false}
      </div>
    </div>
  </div>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  events: portfoliosSelectors.getActivePortfolioModalEvents(state),
  modalEventsCount: portfoliosSelectors.getActivePortfolioModalEventsCount(state),
  modalEventsPaging: state.ui.modalEventsPaging,
  modalEventsLoader: portfoliosSelectors.getActivePortfolioModalEventsLoader(state),
  modalSortOptions: state.ui.modalEventsOptions,
  langCode: state.app.user.preferredLanguageCode,
  countryCode: state.app.user.countryCode,
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawModalContents)



// WEBPACK FOOTER //
// ./src/views/notification-counts/modal-contents.js